var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLifeInsurance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Hospital-Shield--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Hospital Shield Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2a2 2 0 0 0 -2 -2H2A1.91 1.91 0 0 0 0.58 0.59 1.93 1.93 0 0 0 0 2v7.31A15.13 15.13 0 0 0 11.86 24a0.68 0.68 0 0 0 0.2 0 0.71 0.71 0 0 0 0.2 0A15.13 15.13 0 0 0 24 9.2Zm-5.5 10.46a0.65 0.65 0 0 1 -0.65 0.65H15.1a0.5 0.5 0 0 0 -0.5 0.5v2.75a0.65 0.65 0 0 1 -0.6 0.64h-3.9a0.65 0.65 0 0 1 -0.65 -0.65v-2.74a0.5 0.5 0 0 0 -0.5 -0.5h-2.8a0.65 0.65 0 0 1 -0.65 -0.65v-3.9a0.65 0.65 0 0 1 0.65 -0.65H8.9a0.5 0.5 0 0 0 0.5 -0.5V4.66a0.65 0.65 0 0 1 0.65 -0.66H14a0.65 0.65 0 0 1 0.65 0.65v2.76a0.5 0.5 0 0 0 0.5 0.5h2.75a0.65 0.65 0 0 1 0.65 0.65Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLifeInsurance);
export default ForwardRef;